import { API } from "../utils/amplifyWrapper";
import { toast } from "react-toastify";
import _ from 'lodash';
import * as Sentry from '@sentry/react';
import { fetchIntegrationsService } from "../services/integration"

export const goToUpgradePage = async function(history, plan_id=null){

    const getOrganisations = () => {

        return API.get(`main`, `/organisation`);

    }

    let orgs;
    try {
        orgs = (await getOrganisations()).data
    } catch (e) {
        Sentry.captureException(e);
        return toast.error("Something went wrong. Please try again.")
    }

    if(!orgs.length) return toast.error("You dont have any organisations. Please contact support")
    
    const org_id = orgs[0].PK.split("#")[1]

    if(plan_id){
        history.push(`/organisation/${org_id}/upgrade?plan_id=${plan_id}`);
    }else{
        history.push(`/organisation/${org_id}/upgrade`);
    }

    
}

export const goToCurrentIntegration = async function(history){

    const getOrganisations = () => {

        return API.get(`main`, `/organisation`);

    }

    let orgs;
    try {
        orgs = (await getOrganisations()).data
    } catch (e) {
        Sentry.captureException(e);
        return toast.error("Something went wrong. Please try again.")
    }

    if(!orgs.length) return toast.error("You dont have any organisations. Please contact support")

    const org_id = orgs[0].PK.split("#")[1]

    let ints;
    try {
        ints = await fetchIntegrationsService(org_id)
    } catch (e) {
        // Couldn't load integrations (network blip, session issue, etc.) —
        // degrade the same way as "no integrations yet" rather than crashing
        // on a stale/garbage value.
        Sentry.captureException(e);
        history.push(`/organisation/${org_id}/integration`);
        return;
    }

    let currentIntegration = localStorage.getItem("currentIntegration");

    if (currentIntegration && (ints.find(i => i.SK.split("#")[1] === currentIntegration))) {
        history.push(`/organisation/${org_id}/integration/${currentIntegration}/dashboard`);
        return;
    }

    if (!ints || ints.length <= 0) {
        history.push(`/organisation/${org_id}/integration`);
        return;
    }

    const integrationsSorted = _.sortBy(ints, [(integ) => new Date(integ.created_at)])
    currentIntegration = integrationsSorted[integrationsSorted.length - 1].SK.split("#")[1]
    localStorage.setItem("currentIntegration", currentIntegration)
    history.push(`/organisation/${org_id}/integration/${currentIntegration}/dashboard`);
}

export const returnCurrentIntegrationOfOrg = async function(org_id){

    // Unlike goToCurrentIntegration, this is only called from ChangePlan.js's
    // openUpgradeCard, which already wraps this in its own try/catch and
    // aborts the checkout flow on failure — so a fetch failure should
    // propagate as a real rejection here, not get swallowed into a `null`
    // the caller doesn't guard against (it would proceed with a broken
    // `.../integration/null/billing` URL instead of aborting).
    const ints = await fetchIntegrationsService(org_id)

    let currentIntegration = localStorage.getItem("currentIntegration");

    if (currentIntegration && (ints.find(i => i.SK.split("#")[1] === currentIntegration))) {
        return currentIntegration;
    }

    if (!ints || ints.length <= 0) {
        return null;
    }

    const integrationsSorted = _.sortBy(ints, [(integ) => new Date(integ.created_at)])
    currentIntegration = integrationsSorted[integrationsSorted.length - 1].SK.split("#")[1]
    localStorage.setItem("currentIntegration", currentIntegration)

    return currentIntegration
}

